export default {"src":"/_next/static/image/public/images/flags/flag_998.44ec0d0030c4739272c6fe73e9fc0a24.svg","height":16,"width":24};